import { call, put, select } from "redux-saga/effects";
import { Mixpanel } from "../../../services/Mixpanel";
import { setCookie } from "../../../utils/cookies";

import { authActions } from "../../../actions/auth";

// Api
import { register } from "../../../api";

export function* signUp({ payload: { userInfo, history } }) {
  yield put(authActions.startLoading());
  const { response } = yield call(register, userInfo);
  yield put(authActions.finishLoading());

  const lastUrl = localStorage.getItem("lastUrl");

  if (response) {
    yield put(authActions.loginSuccess(response));
    yield call(
      [localStorage, "setItem"],
      "access_token",
      response.profile.token
    );
    yield call(setCookie, "access_token", response.profile.token, 30);
    yield call([localStorage, "setItem"], "firsttime", "true");
    yield call(
      [localStorage, "setItem"],
      "user_info",
      JSON.stringify(response)
    );
    yield call(setCookie, "user_info", encodeURIComponent(JSON.stringify(response)), 30);
    if (lastUrl) {
      yield call([history, "push"], lastUrl);
    } else {
      yield call([history, "push"], `/${response.slug}/profile`);
    }

    Mixpanel.identify(response.profile.email);
    Mixpanel.track("Sign Up");
    Mixpanel.people.set({
      $name: response.profile.first_name,
      $email: response.profile.email,
    });
  } else {
  }
}
